import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesContractFull from './futures-contract-full';

const FuturesContractFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <FuturesContractFull {...props}/>
    </QueryClientProvider>
  );
};

export { FuturesContractFullWidget }
